import { render, staticRenderFns } from "./DownloadedGroupRow.vue?vue&type=template&id=620da936&scoped=true"
import script from "./DownloadedGroupRow.vue?vue&type=script&lang=js"
export * from "./DownloadedGroupRow.vue?vue&type=script&lang=js"
import style0 from "./DownloadedGroupRow.vue?vue&type=style&index=0&id=620da936&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620da936",
  null
  
)

export default component.exports